import {
  AssessmentRounded,
  AssignmentRounded,
  DashboardRounded,
  HelpOutlined,
  LinkRounded,
  ManageAccountsRounded,
  PaymentRounded,
  PeopleAltRounded,
  SettingsRounded,
} from "@mui/icons-material";
import {
  Box,
  Divider,
  ListItemIcon,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import { NavLink, useLocation } from "react-router-dom";
import {
  WORKPLACE_DASHBOARD_URL,
  WORKPLACE_EVALS_URL,
  WORKPLACE_GENERAL_SETTINGS_URL,
  WORKPLACE_INTEGRATIONS_URL,
  WORKPLACE_ROLE_ACCESS_URL,
  WORKPLACE_USERS_URL,
  WORKPLACE_BILLING_AND_SUBSCRIPTION_URL,
  WORKPLACE_AUDIT_LOGS_URL,
} from "../../../utils/routes";

const useStyles = makeStyles()((theme, _params, classes) => ({
  container: {
    width: 240,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: theme.palette.background.dark,
  },
}));

const menuItems = [
  {
    label: "Workplace",
    items: [
      {
        label: "Dashboad",
        icon: DashboardRounded,
        path: WORKPLACE_DASHBOARD_URL,
      },
      // { label: "Evals", icon: AssessmentRounded, path: WORKPLACE_EVALS_URL },
      // {
      //   label: "General Settings",
      //   icon: SettingsRounded,
      //   path: WORKPLACE_GENERAL_SETTINGS_URL,
      // },
    ],
  },
  {
    label: "Management",
    items: [
      { label: "Users", icon: PeopleAltRounded, path: WORKPLACE_USERS_URL },
      {
        label: "Role Access",
        icon: ManageAccountsRounded,
        path: WORKPLACE_ROLE_ACCESS_URL,
      },
      // {
      //   label: "Integrations",
      //   icon: LinkRounded,
      //   path: WORKPLACE_INTEGRATIONS_URL,
      // },
    ],
  },
  // {
  //   label: "Administration",
  //   items: [
  //     {
  //       label: "Billing & Subscription",
  //       icon: PaymentRounded,
  //       path: WORKPLACE_BILLING_AND_SUBSCRIPTION_URL,
  //     },
  //     {
  //       label: "Audit Logs",
  //       icon: AssignmentRounded,
  //       path: WORKPLACE_AUDIT_LOGS_URL,
  //     },
  //   ],
  // },
];

function NavigationMenu() {
  const { classes } = useStyles();
  const location = useLocation();
  const theme = useTheme();
  return (
    <Box className={classes.container}>
      <Box flex={1} pt={1.5} px={1.5}>
        {menuItems.map((item) => {
          const { label, items } = item;
          return (
            <Box key={label} my={1}>
              <Typography variant="overline" color="textSecondary">
                {label}
              </Typography>
              <Box>
                {items.map((item) => {
                  const { label, icon, path } = item;
                  const Icon = icon;
                  const isSelected = location.pathname.startsWith(path);

                  return (
                    <NavLink
                      key={label}
                      to={path}
                      style={{
                        textDecoration: "none",
                        color: theme.palette.text.secondary,
                      }}>
                      <MenuItem
                        // onClick={() => handleClickNavItem(navItem)}
                        selected={isSelected}
                        sx={{
                          height: 40,
                          padding: 0,
                          borderRadius: 2,
                          paddingLeft: 0.5,
                        }}>
                        <ListItemIcon>
                          <Icon />
                        </ListItemIcon>
                        <Typography variant="body2">{label}</Typography>
                      </MenuItem>
                    </NavLink>
                  );
                })}
              </Box>
            </Box>
          );
        })}
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box px={1.5} pb={1.5}>
        <NavLink
          to={""}
          style={{
            textDecoration: "none",
            color: theme.palette.text.secondary,
          }}>
          <MenuItem
            sx={{
              height: 40,
              padding: 0,
              borderRadius: 2,
              paddingLeft: 0.5,
              paddingTop: 1,
              paddingBottom: 1,
            }}>
            <ListItemIcon>
              <HelpOutlined />
            </ListItemIcon>
            <Typography variant="body2">Help & Support</Typography>
          </MenuItem>
        </NavLink>
      </Box>
    </Box>
  );
}

export default NavigationMenu;
